import Pusher from 'pusher-js';

let pusher;

export function createPusher(userId, clientId) {
  if (pusher) return pusher;

  Pusher.logToConsole = process.env.PusherLogging == 'true';
  const pusherInstance = new Pusher(process.env.PusherAppKey, {
    cluster: process.env.PusherAppCluster
  });
  const globalChannel = pusherInstance.subscribe('global-channel');
  const userChannel = pusherInstance.subscribe(userId);
  const clientChannel = pusherInstance.subscribe(clientId);
  pusher = {
    pusherInstance,
    globalChannel,
    userChannel,
    clientChannel
  };
  return pusher;
}
